export default {
  data() {
    return {
      infinitePageIndex: 1,
      infinitePageSize: 10,
      infiniteEnded: false,
      infiniteList: [],
    }
  },
  methods: {
    async getInfiniteList(refresh) {
      if (refresh) {
        this.infiniteList = [];
        this.infinitePageIndex = 1
        this.infiniteEnded = false
      }

      if(this.infinitePageIndex === 1 && this.infiniteList.length>0){
        this.infiniteList = [];
      }

      if (this.infiniteEnded){
        // this.$layer.msg('---我也是有底线的---');
        return false;
      }
      const { infinitePageIndex, infinitePageSize } = this
      const response = await this.getInfiniteData(infinitePageIndex, infinitePageSize)
      const infiniteList = response.data
      if (refresh) {
        this.infiniteList = infiniteList
      } else {
        this.infiniteList.push(...infiniteList)
      }
      // if(!refresh){
        this.infinitePageIndex++
      // }

      if (infiniteList.length < infinitePageSize) this.infiniteEnded = true
    },
  },
}
